import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import FormControlLabel from '@mui/material/FormControlLabel'
import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'
import Stack from '@mui/material/Stack'
import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'
import React, { useCallback } from 'react'

import T from 'T'

import type { ReactivationStartDatesApi } from 'types/api/account/accountReactivation'

type ReactivationStartDatesProps = {
  value: ReactivationStartDatesApi
  todayLabel?: string
  onChange: (value: ReactivationStartDatesApi) => void
}

const LABEL_ID = 'reactivation-start-dates-label'

const ReactivationStartDates = ({ value, todayLabel = T.TODAY, onChange }: ReactivationStartDatesProps) => {
  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => onChange(event.target.value as ReactivationStartDatesApi),
    [onChange]
  )

  return (
    <Stack gap={0.5}>
      <Stack alignItems="center" direction="row" gap={0.5}>
        <Typography fontWeight={600} id={LABEL_ID} variant="body2">
          {T.REACTIVATION_START_DATES}
        </Typography>
        <Tooltip arrow title={T.REACTIVATION_START_DATES_TOOLTIP}>
          <InfoOutlinedIcon aria-label={T.REACTIVATION_START_DATES_TOOLTIP} color="disabled" fontSize="small" />
        </Tooltip>
      </Stack>
      <RadioGroup aria-labelledby={LABEL_ID} value={value} onChange={handleChange}>
        <FormControlLabel control={<Radio size="small" />} label={<Typography variant="body2">{todayLabel}</Typography>} value="TODAY" />
        <FormControlLabel
          control={<Radio size="small" />}
          label={
            <Typography variant="body2">
              {T.REACTIVATION_START_DATES_KEEP_ORIGINAL}
              <Typography color="text.secondary" component="span" ml={0.5} variant="body2">
                {T.REACTIVATION_START_DATES_KEEP_ORIGINAL_WARNING}
              </Typography>
            </Typography>
          }
          value="KEEP_ORIGINAL"
        />
      </RadioGroup>
    </Stack>
  )
}

export default ReactivationStartDates
